import { render, staticRenderFns } from "./EditProjectIssueDetails.vue?vue&type=template&id=47ecc9c5&scoped=true"
import script from "./EditProjectIssueDetails.vue?vue&type=script&lang=js"
export * from "./EditProjectIssueDetails.vue?vue&type=script&lang=js"
import style0 from "./EditProjectIssueDetails.vue?vue&type=style&index=0&id=47ecc9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ecc9c5",
  null
  
)

export default component.exports